import { KeyedMutator } from "swr";

import { API_URL } from "constants/api";
import { useSwr } from "hooks/useSwr";

type FetchLatestNewsResponse = LatestNewsItem | null;

const useFetchLatestNews = (): {
  latestNews: LatestNewsItem | null;
  error: Error | null;
  mutate: KeyedMutator<FetchLatestNewsResponse>;
  isLoading?: boolean;
} => {
  const { data, error, mutate, isValidating } = useSwr<FetchLatestNewsResponse>(`${API_URL}/news/latest/homeDisplay`, {
    revalidateIfStale: false,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  return {
    latestNews: data ?? null,
    error: error ?? null,
    mutate,
    isLoading: !data && isValidating,
  };
};

export default useFetchLatestNews;
